import { styled } from '@mui/material/styles';
import MuiChip from '@mui/material/Chip';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';

const OUTLINE = '1px solid rgba(0, 0, 0, 0.12)';

const LABEL_TEXT = {
    fontFamily: 'Rubik, sans-serif',
    color: 'var(--text-primary)',
    fontSize: '12px',
    lineHeight: '14px',
};

const StyledChip = styled(MuiChip)({
    marginRight: '8px',
    height: '30px',
    maxWidth: '250px',
    border: OUTLINE,
    '& .MuiChip-label': {
        ...LABEL_TEXT,
        paddingLeft: '10px',
    },
    '& .MuiChip-avatar': {
        marginLeft: 6,
    },
});

const StyledSelectableChip = styled(MuiChip, { shouldForwardProp: prop => prop !== 'selected' })(({ selected }) => ({
    height: '30px',
    maxWidth: '100%',
    backgroundColor: selected ? 'var(--action-highlight)' : 'transparent',
    border: selected ? '1px solid var(--primary-main)' : OUTLINE,
    '&:hover': {
        backgroundColor: selected ? 'var(--action-highlight)' : 'var(--action-hover)',
    },
    '& .MuiChip-label': LABEL_TEXT,
    '& .MuiChip-icon': {
        color: 'var(--primary-main)',
        fontSize: 14,
        marginLeft: 8,
    },
}));

export const Chip = ({ label, onClick, onDelete, avatar }) => {
    return (
        <StyledChip
            key={label}
            label={label}
            onClick={onClick}
            onDelete={onDelete}
            avatar={avatar}
            variant="outlined"
            size="small"
        />
    );
};

export const SelectableChip = ({ label, selected = false, checkmark = false, disabled, onClick, onDelete }) => (
    <StyledSelectableChip
        label={label}
        selected={selected}
        icon={checkmark && selected ? <CheckRoundedIcon /> : undefined}
        disabled={disabled}
        onClick={onClick}
        onDelete={onDelete}
        aria-pressed={onClick ? selected : undefined}
        size="small"
    />
);
